import React, {
  useCallback, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import {
  // Common18NextProvider,
  LyInPlaceLoading,
} from 'lidya-common-components';
// import i18n from '../../common/i18n';
import { requests } from '../../common/requests';
import { COUNTRY_LANGUAGE_LIST } from '../../common/webSiteLanguages';
// import { POSSIBLE_FORMS } from './sign.up.modal.component';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { useDataLayer } from '../../../hooks/useDataLayer';
import { SignUpFormMemo, initvalues, POSSIBLE_FORMS } from './sign.up.memo.form';
// import '../../../styles/common/form/form.agg.less';

const SignUpForm = function ({
  signupType, setImage, showModal, isCreateAccount,
}) {
  const { t } = useTranslation();
  const registerEvent = useDataLayer();
  const [initialValues, setInitialValues] = useState(initvalues);
  const [repeatedEmail, setRepeatedEmail] = useState();
  const [onBoardSuccess, setOnBoardSuccess] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { country } = useGlobalData();
  const getKeysToTranslate = useCallback(() => {
    const messages = {};

    switch (signupType) {
      case POSSIBLE_FORMS.INVESTORS:
        messages.success = 'web.investors.invest.form.success';
        messages.subtitle = 'web.investors.invest.form.subtitle';
        messages.subSubtitle = 'web.investors.invest.form.subSubtitle';
        messages.noSuccess = 'web.sign.up.form.news.insuccess.title';
        messages.noSubtitle = 'web.sign.up.form.news.insuccess.subtitle';
        messages.noSubSubtitle = 'web.sign.up.form.news.insuccess.secondsubtitle';
        messages.createTitle = 'web.sign.up.form.create.account';
        messages.submitButton = 'web.sign.up.form.create.btn';
        break;
      case POSSIBLE_FORMS.SIGN_UP:
        messages.success = 'web.sign.up.form.success.title';
        messages.subtitle = 'web.sign.up.form.success.subtitle';
        messages.subSubtitle = isCreateAccount
          ? 'web.sign.up.form.success.secondsubtitle'
          : 'web.sign.up.form.success.secondsubtitle.sign.up';
        messages.noSuccess = 'web.sign.up.form.insuccess.title';
        messages.noSubtitle = 'web.sign.up.form.insuccess.subtitle';
        messages.noSubSubtitle = 'web.sign.up.form.insuccess.secondsubtitle';
        messages.createTitle = 'web.sign.up.form.create.account';
        messages.submitButton = isCreateAccount
          ? 'web.sign.up.form.create.btn'
          : 'web.sign.up.form.sign.btn';
        break;
      default:
        messages.success = 'web.sign.up.form.news.success.title';
        messages.subtitle = !repeatedEmail
          ? 'web.sign.up.form.news.success.subtitle'
          : 'web.sign.up.form.news.exist.success.subtitle';
        messages.subSubtitle = isCreateAccount
          ? 'web.sign.up.form.success.secondsubtitle'
          : 'web.sign.up.form.success.secondsubtitle.sign.up';
        messages.noSuccess = 'web.sign.up.form.news.insuccess.title';
        messages.noSubtitle = 'web.sign.up.form.news.insuccess.subtitle';
        messages.noSubSubtitle = 'web.sign.up.form.news.insuccess.secondsubtitle';
        messages.createTitle = 'web.sign.up.form.news.title';
        messages.submitButton = 'web.sign.up.form.news.btn';
        break;
    }
    return messages;
  }, [signupType, repeatedEmail, isCreateAccount]);

  const onSubmit = useCallback(
    (nValues) => {
      setIsSubmitting(true);
      const prefix = nValues.telephone_prefix
        ? nValues.telephone_prefix.replace(/[^0-9]/g, '')
        : undefined;
      const phone = nValues.telephone_number
        ? nValues.telephone_number.replace(/[^0-9]/g, '')
        : undefined;
      const isNigeriaNewAccount = country.toUpperCase() === COUNTRY_LANGUAGE_LIST.ng.code.toUpperCase()
        && isCreateAccount;
      let values = isNigeriaNewAccount
        ? {
          ...nValues,
          telephone_prefix: prefix,
          telephone_number: phone,
        }
        : {
          first_name: nValues.firstName,
          last_name: nValues.lastName,
          email: nValues.email,
          email_confirmation: nValues.rEmail,
        };
      values = {
        ...values,
        country_code: country.toUpperCase(),
        phone_prefix: prefix,
        phone_number: phone,
        signupType,
        register_in_sardis: !isNigeriaNewAccount,
      };
      requests.sendRegisterRequest(values).then((response) => {
        registerEvent({ event: 'register-form-submitted' });
        const { status, emailExists } = response;
        setInitialValues(initvalues);
        setOnBoardSuccess(status);
        setRepeatedEmail(emailExists);
        setIsSubmitting(false);
        setImage(`signup_submitted_${country}`);
      });
    },
    [country, isCreateAccount, signupType, registerEvent, setImage],
  );

  const UseResponse = useCallback(() => {
    const messages = getKeysToTranslate();
    switch (signupType) {
      case POSSIBLE_FORMS.INVESTORS:
        messages.subtitle = !repeatedEmail
          ? 'web.investors.invest.form.subtitle'
          : 'web.sign.up.form.news.exist.success.subtitle';
        break;
      case POSSIBLE_FORMS.SIGN_UP:
        messages.subtitle = !repeatedEmail
          ? 'web.sign.up.form.success.subtitle'
          : 'web.sign.up.form.news.exist.success.subtitle';
        break;
      default:
        messages.subtitle = !repeatedEmail
          ? 'web.sign.up.form.news.success.subtitle'
          : 'web.sign.up.form.news.exist.success.subtitle';
        break;
    }
    const html = onBoardSuccess ? (
      <div className="m-signUp__card -form">
        <h1 className="a-signUp__successTitle">
          <Trans>{messages.success}</Trans>
        </h1>
        <h3 className="a-signUp__successSubTitle -top">
          <Trans>{messages.subtitle}</Trans>
        </h3>
        <h3 className="a-signUp__successSubTitle">
          <Trans>{messages.subSubtitle}</Trans>
        </h3>
      </div>
    ) : (
      <div className="m-signUp__card -form">
        <h1 className="a-signUp__insuccessTitle">
          <Trans>{messages.noSuccess}</Trans>
        </h1>
        <h3 className="a-signUp__insuccessSubTitle -top">
          <Trans>{messages.noSubtitle}</Trans>
        </h3>
        <h3 className="a-signUp__insuccessSubTitle">
          <Trans>{messages.noSubSubtitle}</Trans>
        </h3>
      </div>
    );
    return html;
  }, [signupType, getKeysToTranslate, onBoardSuccess, repeatedEmail]);

  const UseForm = useCallback(
    ({ loading }) => {
      const messages = getKeysToTranslate();
      return (
        <div className="m-signUp__card -form m-loadingParent">
          <LyInPlaceLoading visible={loading} />
          <h1 className="a-signUp__title">
            <Trans>{messages.createTitle}</Trans>
          </h1>
          <SignUpFormMemo
            initialValues={initialValues}
            onSubmit={onSubmit}
            submitLabel={t(messages.submitButton)}
          />
        </div>
      );
    },
    [initialValues, getKeysToTranslate, t, onSubmit],
  );

  const VisibleState = useCallback(
    () => (onBoardSuccess === undefined ? (
      <UseForm loading={isSubmitting} />
    ) : (
      <UseResponse />
    )),
    [onBoardSuccess, isSubmitting],
  );

  useEffect(() => {
    if (!showModal) setOnBoardSuccess(undefined);
  }, [showModal]);

  return <VisibleState />;
};

SignUpForm.propTypes = {
  setImage: PropTypes.func,
  signupType: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  isCreateAccount: PropTypes.bool,
};

SignUpForm.defaultProps = {
  // signupType: POSSIBLE_FORMS.NEWSLETTER,
  setImage: () => {},
  showModal: false,
  isCreateAccount: false,
};

export default SignUpForm;
